module.exports = __webpack_public_path__ + "img/img_download_android.59ae09cc.png";